/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Absence, AbsenceSummaryEntry, Tour, TourAppointmentClass, TourClass, TourMonthStatistics } from '@shared/models';
import { TourViewMode } from '@shared/models/tour-view-mode';
import { Location } from '@shared/models/location';
import { TourView } from '@tours/models/tour-view';

export interface ToursState {
  tours: Tour[];
  currentTour?: Tour;
  locations: Location[],
  currentLocation?: Location,
  actionPending: boolean;
  hasError: boolean;
  currentDate: Date;
  constructionSiteId?: string;
  currentTourClass: TourClass;
  isSidebarExpanded: boolean;
  tourAppointmentClasses: TourAppointmentClass[];
  currentAbsences: Absence[];
  absenceSummary: AbsenceSummaryEntry[];
  monthlyStatistics?: TourMonthStatistics;
  currentView: TourView;
  viewModeFilters?: {
    [viewMode: string]: {
      stateFilterValues: string[]
    }
  };
}

export const initialState: ToursState = {
  tours: [],
  locations: [],
  currentLocation: null,
  hasError: false,
  currentTour: null,
  actionPending: false,
  currentDate: new Date(),
  currentTourClass: TourClass.All,
  isSidebarExpanded: true,
  tourAppointmentClasses: [],
  currentAbsences: [],
  absenceSummary: [],
  currentView: TourView.Tours,
  viewModeFilters: Object.values(TourViewMode).reduce((o, viewMode) => {
    o[viewMode] = {stateFilterValues: []};
    return o;
  }, {})
};
